import { render } from "./Providers.vue?vue&type=template&id=6be15e30&ts=true"
import script from "./Providers.ts?vue&type=script&lang=ts&external"
export * from "./Providers.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__